export default __webpack_public_path__ + "static/media/Version (1) - Early Prop_15.d43eb015.jpg";